<template>
  <div class="side-menu">
    <div class="side-menu-close-btn" @click="closeMenu">
      <svg
        width="36"
        height="36"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
          fill="white"
        />
      </svg>
    </div>

    <ul>
      <li v-for="menu in menus" :key="menu.id">
        <button @click="toggleDropdown(menu.id)">
          {{ menu.title }}
        </button>
        <ul v-if="isDropdownOpen(menu.id)" class="side-dropdown-menu">
          <li v-for="item in menu.dropdown" :key="item.name">
            <router-link :to="item.link" @click="selectMenu(item)">{{
              item.name
            }}</router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    menus: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      openDropdownId: null, // 현재 열려 있는 dropdown ID
    };
  },
  methods: {
    toggleDropdown(id) {
      // 클릭한 메뉴의 dropdown을 토글
      this.openDropdownId = this.openDropdownId === id ? null : id;
    },
    isDropdownOpen(id) {
      // dropdown이 열려 있는지 확인
      return this.openDropdownId === id;
    },

    closeMenu() {
      this.$emit("close"); // 부모 컴포넌트에 'close' 이벤트 emit
    },

    selectMenu(item) {
      // 메뉴 항목을 클릭하면 부모에게 선택된 메뉴 전달
      this.$emit("menuSelected", item); // 부모로 선택된 메뉴 정보 전달
      this.closeMenu(); // 메뉴 닫기
    },
  },
};
</script>

<style>
@import "../assets/css/sidemenu.css";
</style>
